import { prefix } from "./constants.js";
import { createAction } from "typesafe-actions";
const resetCreateResult = createAction(`${prefix}/RESET`);
export {
  resetCreateResult
};
//# sourceMappingURL=actions.js.map
